import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';
import { nuc } from '../../../utils';

import { getQueryKey } from './useGetGlobalConclusions';

const deleteGlobalConclusion = async (revisionLocator: string) => {
  return remove(`/api/v2/revisions/${nuc(revisionLocator)}/correction/global-conclusions`);
};

export const useDeleteGlobalConclusion = (revisionLocator: string) => {
  return useToastedMutation({
    mutationFn: () => deleteGlobalConclusion(revisionLocator),
    successToastMessage: 'Global conclusion overrides deleted successfully.',
    errorToastMessage: 'Failed to delete global conclusion overrides.',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKey(revisionLocator) });
    },
  });
};
